import { RootState } from '@app/redux/root-reducer';

export const selectAddProjectState = (store: RootState) => store.projectReducer.addProject;
export const selectProjectState = (store: RootState) => store.projectReducer.projects;
export const selectUpdateProjectStatusState = (store: RootState) =>
  store.projectReducer.updateProjectStatus;
export const selectProjectDetailsState = (store: RootState) => store.projectReducer.projectDetails;
export const selectUpdateProjectState = (store: RootState) => store.projectReducer.updateProject;
